import { featureFlagName } from "utils";

import { useAuthStore } from "src/auth";

export function isFeatureFlagEnabled(
  flagName: string,
  featureFlags?: string[],
): boolean {
  return featureFlags?.includes(flagName) === true;
}

export function useFeatureFlagEnabled(flagName: string): boolean {
  const authStore = useAuthStore();
  return isFeatureFlagEnabled(flagName, authStore.maybeUser?.featureFlags);
}

export function useIsAiIntegrationEnabled(): boolean {
  return useFeatureFlagEnabled(featureFlagName.aiIntegration);
}
